import { render, staticRenderFns } from "./rolePersonnel.vue?vue&type=template&id=07451fbe&scoped=true"
import script from "./rolePersonnel.vue?vue&type=script&lang=js"
export * from "./rolePersonnel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07451fbe",
  null
  
)

export default component.exports